// element-ui按需引入 导入自己需要的组件
import {
    Dialog,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Input,
    Checkbox,
    Select,
    Button,
    Table,
    TableColumn,
    Breadcrumb,
    BreadcrumbItem,
    Form,
    FormItem,
    Upload,
    Progress,
    Loading,
    MessageBox,
    Message,
    Notification,
    // CheckboxButton,
    // Pagination,
    // Autocomplete,
    // Menu,
    // Submenu,
    // MenuItem,
    // MenuItemGroup,
    // InputNumber,
    Radio,
    RadioGroup,
    // RadioButton,
    // CheckboxGroup,
    // Switch,
    Option,
    OptionGroup,
    // ButtonGroup,
    // DatePicker,
    // TimeSelect,
    // TimePicker,
    // Popover,
    Tooltip,
    // Tabs,
    // TabPane,
    // Tag,
    // Tree,
    // Alert,
    Slider,
    // Icon,
    // Row,
    // Col,
    // Spinner,
    // Badge,
    // Card,
    // Rate,
    // Steps,
    // Step,
    // Carousel,
    // CarouselItem,
    // Collapse,
    // CollapseItem,
    // Cascader,
    // ColorPicker,
    // Transfer,
    // Container,
    // Header,
    // Aside,
    // Main,
    // Footer,
    // Timeline,
    // TimelineItem,
    // Link,
    // Divider,
    // Image,
    // Calendar,
    // Backtop,
    // PageHeader,
    // CascaderPanel
  } from 'element-ui'
  
  import tableMixins from './tableMixins'
  delete Table.components.TableBody.computed.data
  // 混入虚拟列表逻辑
  Table.components.TableBody.mixins.push(tableMixins)
  
  const element = {
    install: function (Vue) {
      Vue.use(Dialog);
      Vue.use(Dropdown);
      Vue.use(DropdownMenu);
      Vue.use(DropdownItem);
      Vue.use(Input);
      Vue.use(Checkbox);
      Vue.use(Select);
      Vue.use(Button);
      Vue.use(Table);
      Vue.use(TableColumn);
      Vue.use(Breadcrumb);
      Vue.use(BreadcrumbItem);
      Vue.use(Form);
      Vue.use(FormItem);
      Vue.use(Upload);
      Vue.use(Progress);
  
      // 以下注释部分暂未用到，后期需要用到时再加入引用
      // Vue.use(Pagination);
      // Vue.use(Autocomplete);
      // Vue.use(Menu);
      // Vue.use(Submenu);
      // Vue.use(MenuItem);
      // Vue.use(MenuItemGroup);
      // Vue.use(InputNumber);
      Vue.use(Radio);
      Vue.use(RadioGroup);
      // Vue.use(RadioButton);
      // Vue.use(CheckboxButton);
      // Vue.use(CheckboxGroup);
      // Vue.use(Switch);
      Vue.use(Option);
      Vue.use(OptionGroup);
      // Vue.use(ButtonGroup);
      // Vue.use(DatePicker);
      // Vue.use(TimeSelect);
      // Vue.use(TimePicker);
      // Vue.use(Popover);
      Vue.use(Tooltip);
      // Vue.use(Tabs);
      // Vue.use(TabPane);
      // Vue.use(Tag);
      // Vue.use(Tree);
      // Vue.use(Alert);
      Vue.use(Slider);
      // Vue.use(Icon);
      // Vue.use(Row);
      // Vue.use(Col);
      // Vue.use(Spinner);
      // Vue.use(Badge);
      // Vue.use(Card);
      // Vue.use(Rate);
      // Vue.use(Steps);
      // Vue.use(Step);
      // Vue.use(Carousel);
      // Vue.use(CarouselItem);
      // Vue.use(Collapse);
      // Vue.use(CollapseItem);
      // Vue.use(Cascader);
      // Vue.use(ColorPicker);
      // Vue.use(Transfer);
      // Vue.use(Container);
      // Vue.use(Header);
      // Vue.use(Aside);
      // Vue.use(Main);
      // Vue.use(Footer);
      // Vue.use(Timeline);
      // Vue.use(TimelineItem);
      // Vue.use(Link);
      // Vue.use(Divider);
      // Vue.use(Image);
      // Vue.use(Calendar);
      // Vue.use(Backtop);
      // Vue.use(PageHeader);
      // Vue.use(CascaderPanel);
  
      Vue.use(Loading.directive);
  
      // 在vue原型上挂载全局方法
      Vue.prototype.$loading = Loading.service;
      Vue.prototype.$msgbox = MessageBox;
      Vue.prototype.$alert = MessageBox.alert;
      Vue.prototype.$confirm = MessageBox.confirm;
      Vue.prototype.$prompt = MessageBox.prompt;
      Vue.prototype.$notify = Notification;
      Vue.prototype.$message = Message;
    }
  }
  export default element


// WEBPACK FOOTER //
// ./src/plugins/element-ui.js